import { render, staticRenderFns } from "./EmployerOtherCompensationPercentInput.vue?vue&type=template&id=0622ef96&"
import script from "./EmployerOtherCompensationPercentInput.vue?vue&type=script&lang=js&"
export * from "./EmployerOtherCompensationPercentInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports